import { Intent } from '@blueprintjs/core';
import { ButtonSave } from 'components/buttons';
import { FormSwitch } from 'components/form-fields';
import { AlertUnsavedData, NotificationToaster } from 'components/notifications';
import { useDirtyData } from 'hooks/useDirtyData';
import React, { useEffect, useState } from 'react';
import { CheckService } from 'services/CheckService';

export function CheckSettingsSettings() {
    const defaultSettings = {
        allowGlobalTemplatesToBeCompleted: false
    };

    const [checkSettings, setCheckSettings] = useState(defaultSettings);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const isDataDirty = useDirtyData(checkSettings);

    useEffect(initialLoad, []);

    function initialLoad() {
        CheckService.getCheckSettings().then(
            (result) => {
                setCheckSettings(result);
                setLoading(false);
            },
            () => {
                NotificationToaster.show(Intent.DANGER, "Could not load settings. Please refresh the page.");
            });
    }

    function saveSettings() {
        setSaving(true);

        CheckService.saveCheckSettings(checkSettings)
            .then(
                () => {
                    NotificationToaster.show(Intent.SUCCESS, "Settings updated successfully.");
                    setSaving(false);
                },
                () => {
                    NotificationToaster.show(Intent.DANGER, "Could not save settings. Please try again.");
                    setSaving(false);
                },
            );
    }

    function onGlobalTemplatesActiveUpdate(event) {
        const settingsClone = { ...checkSettings };

        settingsClone.allowGlobalTemplatesToBeCompleted = event.target.checked;

        setCheckSettings(settingsClone);
    }

    return (
        <div className="row">
            <h2>Check Settings</h2>
            <FormSwitch
                disabled={saving}
                headingText="Standard Templates"
                onChange={onGlobalTemplatesActiveUpdate}
                loading={loading}
                helperText={
                    <h4 className="helper-text">
                        This setting allows the completion of pre-set standard templates created by Logistics UK in the Vision app.
                        <br />
                        Turn this setting off to ensure your users only use Checks created on your account.
                    </h4>
                }
                checked={checkSettings.allowGlobalTemplatesToBeCompleted}
                id="global-templates-switch"
            ></FormSwitch>

            <AlertUnsavedData
                isDirty={isDataDirty}>
            </AlertUnsavedData>
            <ButtonSave
                onClick={saveSettings}
                disabled={saving}
                loading={loading}
            ></ButtonSave>
        </div>
    );
}